module.exports = __webpack_public_path__ + "img/footbg.ba1bd8c5.png";